module.exports = __webpack_public_path__ + "static/media/aplausos.a1ef0f9b.svg";